import { ChartTemplate } from '@/chart/components/chart-template';
import generateChart from './components/chart-generator';

/**
 * Parent class for Chart Instantiation. Responsible for putting together all
 * chart options, chart props, and data building to be passed to the
 * Chart Generator HOC
 *
 * @export Base Class
 * @class Charts
 */
export class Charts {
  constructor(opts) {
    const { DataBuilder, name, options, baseType, plugins, chartProps } = opts;
    this.DataBuilder = DataBuilder;
    this.name = name;
    this.options = options;
    this.baseType = baseType;
    this.chartPlugins = plugins;
    this.chartProps = chartProps; // TODO: Let's name this component props or passedProps
  }

  /**
   * Called by the HOC to get the data and pass to chart template
   *
   * @memberof Charts
   */
  getChartData = (data, param) => {
    const dataBuilder = new this.DataBuilder(data, param);
    dataBuilder.setBuilderOptions(this.builderOptions);
    return dataBuilder.retrieveDatasets;
  };

  /**
   * Responsible for determining which plugins to be activated
   *
   * @readonly
   * @memberof Charts
   */
  get plugins() {
    return this.chartProps.enablePlugins ? this.chartPlugins : [];
  }

  get builderOptions() {
    return this.chartProps?.builderOptions || {};
  }

  /**
   * Gets all the chart options, databuilder etc. as prepares them as "props" to chart generator
   *
   * @readonly
   * @memberof Charts
   */
  get props() {
    // TODO: This is very confusing. These are the chart props I think. Find better name
    return {
      dataGetter: this.getChartData,
      name: this.name,
      options: this.options,
      baseType: this.baseType,
      plugins: this.plugins,
    };
  }

  /**
   * Getter for calling Chart Generator and returning a connected chart component
   *
   * @readonly
   * @memberof Charts
   */
  get chart() {
    // used "generate chart" here b/c redux's HOC is called "connect" which is a verb
    const Chart = generateChart(ChartTemplate, {
      ...this.props,
      ...this.chartProps,
    });
    return Chart;
  }
}
